import { Injectable } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

import {
  ChangeToolSizeEventType,
  HotKey,
  HotKeySettings,
  ToolListServiceKeyActionName,
  ToolListServiceKeyActionNameList,
} from '@viewer/data';
import { KeyInteractionService } from 'src/app/interaction';

/**
 * Service is responsible for logic which should be executed only once for the tools,
 * because some of the tools might be initialized several times during working in the project
 */
@Injectable()
export class ToolListService {
  private _changeToolSizeEvent$ = new Subject<ChangeToolSizeEventType>();
  private _unsubscribe$!: Subject<void>;

  constructor(private _keyInteractionService: KeyInteractionService) {}

  init(): void {
    this._unsubscribe$ = new Subject<void>();
    this._initializeHotKeys();
  }

  destroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();

    this._keyInteractionService.removeKeySettingsList([
      ...ToolListServiceKeyActionNameList,
    ]);
  }

  public getChangeToolSizeEvent(): Observable<ChangeToolSizeEventType> {
    return this._changeToolSizeEvent$.asObservable();
  }

  private _initializeHotKeys(): void {
    this._keyInteractionService
      .initializeHotKey(
        HotKey.BracketRight,
        new HotKeySettings<ToolListServiceKeyActionName>({
          keyActionName: 'IncreaseToolSize',
        })
      )
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => {
        this._changeToolSizeEvent$.next('INCREASE');
      });

    this._keyInteractionService
      .initializeHotKey(
        HotKey.BracketLeft,
        new HotKeySettings<ToolListServiceKeyActionName>({
          keyActionName: 'DecreaseToolSize',
        })
      )
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => {
        this._changeToolSizeEvent$.next('DECREASE');
      });
  }
}
